import React, { useState, useEffect } from 'react';
import { notificationService } from '../../services/api';

function NotificationsManagement() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ title: '', message: '', type: 'info' });

  useEffect(() => {
    loadNotifications();
  }, []);

  const loadNotifications = async () => {
    try {
      const data = await notificationService.index();
      setNotifications(data.data || data || []);
    } catch (error) {
      console.error('Error loading notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await notificationService.store(formData);
      setShowModal(false);
      setFormData({ title: '', message: '', type: 'info' });
      loadNotifications();
    } catch (error) {
      console.error('Error sending notification:', error);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Notifications</h2>
        <button onClick={() => setShowModal(true)} className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">Send Notification</button>
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Title</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Message</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {notifications.map((n) => (
              <tr key={n.id}>
                <td className="px-6 py-4 whitespace-nowrap text-sm">{n.title}</td>
                <td className="px-6 py-4 text-sm">{n.message}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm capitalize">{n.type}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm">{new Date(n.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {notifications.length === 0 && <div className="text-center py-8 text-gray-500">No notifications found</div>}
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg w-full max-w-lg">
            <h3 className="text-lg font-semibold mb-4">Send Notification</h3>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input required placeholder="Title" value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })} className="w-full border rounded p-2" />
              <textarea required placeholder="Message" value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} className="w-full border rounded p-2" />
              <select value={formData.type} onChange={(e) => setFormData({ ...formData, type: e.target.value })} className="w-full border rounded p-2">
                <option value="info">Info</option>
                <option value="warning">Warning</option>
                <option value="success">Success</option>
                <option value="error">Error</option>
              </select>
              <div className="flex justify-end gap-3">
                <button type="button" onClick={() => setShowModal(false)} className="px-4 py-2 border rounded">Cancel</button>
                <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded">Send</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default NotificationsManagement;
